<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 18:09:38
 * @Description: App.vue
-->
<template>
	<div id="app">
		<a-config-provider :locale="locale">
			<router-view />
		</a-config-provider>
	</div>
</template>

<script>
import "./App.scss";
// vant
import { Locale } from "vant";
import zhCN from "vant/es/locale/lang/zh-CN";
import enUS from "vant/es/locale/lang/en-US";
// antd vue
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import en_US from "ant-design-vue/lib/locale-provider/en_US";
import moment from "moment";
import { currentLanguage } from "@/utils/helpers";
// import "moment/locale/zh-cn";
// moment.locale("zh-cn");

export default {
	name: "App",
	data() {
		return {
			locale: zh_CN,
		};
	},
	created() {
		this.languageChange();
	},
	mounted() {
		this.$bus.on("change_lang", () => {
			this.languageChange();
		});
	},
	methods: {
		languageChange() {
			let language = currentLanguage();
			if (language == "en") {
				this.locale = en_US;
				moment.locale("en");
				Locale.use("en-US", enUS);
			} else {
				this.locale = zh_CN;
				moment.locale("zh-cn");
				Locale.use("zh-CN", zhCN);
			}
		},
	},
};
</script>

<style lang="scss">
#app {
	width: 100%;
	height: 100%;
}
</style>
